module.exports = __webpack_public_path__ + "static/media/telescope.e6a544eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/telescope.png
// module id = 583
// module chunks = 0